var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "conecta-equipos", attrs: { xs12: "", sm12: "" } },
    [
      _c("EquiposFilter", { on: { filters: _vm.handleFilters } }),
      _c("v-divider"),
      _c("EquiposActions", {
        attrs: { paramApi: _vm.paramApi, dataList: _vm.dataList },
        on: { openModal: _vm.handleCreate }
      }),
      _c("MantenedorGridSinCodigo", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad
        }
      }),
      _vm.dialogVerDetalle
        ? _c("EquiposVerDetalle", {
            attrs: { data: _vm.data },
            on: {
              cerrar: _vm.handleCloseModal,
              ModalVerDetalleEquipoEmit: function($event) {
                return _vm.ModaVerDetalleCallback($event)
              }
            }
          })
        : _vm._e(),
      _vm.dialogEditar
        ? _c("EquiposEditar", {
            attrs: { data: _vm.data, statusFinished: false },
            on: { cerrar: _vm.handleCloseModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }